import { useEffect, useRef } from "react";

export const useControlPolling = (open, fileDetails, refetch) => {
  const pollingIntervalRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const anyProcessing = fileDetails.some((file) => file.isFileValid === null);

    if (anyProcessing) {
      if (!pollingIntervalRef.current) {
        pollingIntervalRef.current = setInterval(() => {
          refetch();
        }, 5000);
      }
    } else {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    }

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [fileDetails, open, refetch]);
};
